import { IExportConfiguration } from "./export-configuration.model";

export const showExportSettingsTooltip: string = 'show_export_settings_tooltip';

export interface IExportSettingsFe {
  showExportSettingsTooltip: boolean;
  availableConfiguration: IExportConfiguration;
  defaultConfiguration: IExportConfiguration;
  savedConfiguration: IExportConfiguration;
}
